import Dropdown from './dropdown';

export default {
  init: function (selector) {
    const dropdowns = document.querySelectorAll(selector);

    if (dropdowns && dropdowns.length) {
      [...dropdowns].map(item => {
        const dropdown = new Dropdown(item);
        dropdown.init();
      });
    }
  }
};
